import React from "react";
import {PageHeading} from "peggirkit";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import {AvailableCategory, Product} from "@/data/entities/menu";
import ProductButton from "@widgets/pos/order/menu/products/ProductButton";

type Props = OrderEditorTabProps & {
    categoryIndex: number,
    category: AvailableCategory,
};

const ProductsPage = ({categoryIndex, category, isPending}: Props) => {
    return (
        <div
            data-category-index={categoryIndex}
            className={"w-full flex flex-col items-stretch justify-start gap-4"}
        >
            <PageHeading
                title={category.name}
            />

            <ul className={"w-full grid grid-cols-3 gap-4 items-start"}>
                {category.sortedProducts.map((product: Product) =>
                    <li key={product.id}>
                        <ProductButton
                            product={product}
                            isPending={isPending}
                        />
                    </li>
                )}
            </ul>
        </div>
    );
};

export default ProductsPage;